import(/* webpackMode: "eager", webpackExports: ["DocsChrome"] */ "/home/runner/work/bytegate-cloud-platform/bytegate-cloud-platform/components/docs/DocsChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/bytegate-cloud-platform/bytegate-cloud-platform/node_modules/lucide-react/dist/esm/Icon.mjs");
